<template>
  <v-container fluid style="margin: 0px">
    <v-card
      elevation="0"
      style="
        margin-top: 0px !important;
        margin-bottom: -30px !important;
        overflow: hidden;
        background-color: transparent;
      "
      class="px-5 py-1"
    >
      <v-row
        v-if="mostrarFiltro"
        class="custom-filter-background fill-width d-flex"
      >
        <template v-for="filtro in filtrosObrigatorios">
          <v-col
            v-if="filtro.tipo === 'multiselect'"
            :key="`${filtro.campo}-obrigatorio`"
            cols="12"
            sm="6"
            md="4"
          >
            <span class="filter-label">{{ filtro.label }}</span>
            <v-select
              v-model="valoresFiltros[filtro.campo]"
              :items="filtro.opcoes"
              :label="filtro.label"
              multiple
              dense
              solo-inverted
              class="compact-field"
              :error-messages="getErrorMessages(filtro.campo)"
              @change="clearFieldErrors(filtro.campo, 'geral')"
            >
              <template v-slot:selection="{ item, index }">
                <span
                  v-if="
                    shouldShowSelection(index, valoresFiltros[filtro.campo])
                  "
                >
                  {{ item }}
                  <span
                    v-if="
                      shouldShowSelectionComma(
                        index,
                        valoresFiltros[filtro.campo],
                      )
                    "
                  >
                    ,
                  </span>
                </span>
                <span v-else-if="index === 2"> ... </span>
              </template>
            </v-select>
          </v-col>

          <template v-if="filtro.tipo === 'daterange'">
            <v-col
              :key="`${filtro.campo}-inicio-obrigatorio`"
              cols="12"
              sm="6"
              md="4"
            >
              <span class="filter-label">{{ filtro.label }} - Inicial</span>
              <v-menu
                v-model="menusDatas[`${filtro.campo}-inicio`]"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(getRangeValue(filtro.campo, 'inicio'))"
                    label="Data Inicial"
                    dense
                    solo-inverted
                    readonly
                    class="compact-field"
                    :error-messages="getErrorMessages(filtro.campo, 'inicio')"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  :value="getRangeValue(filtro.campo, 'inicio')"
                  @input="updateDateRange(filtro.campo, 'inicio', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col
              :key="`${filtro.campo}-fim-obrigatorio`"
              cols="12"
              sm="6"
              md="4"
            >
              <span class="filter-label">{{ filtro.label }} - Final</span>
              <v-menu
                v-model="menusDatas[`${filtro.campo}-fim`]"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(getRangeValue(filtro.campo, 'fim'))"
                    label="Data Final"
                    dense
                    solo-inverted
                    readonly
                    class="compact-field"
                    :error-messages="getErrorMessages(filtro.campo, 'fim')"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  :value="getRangeValue(filtro.campo, 'fim')"
                  @input="updateDateRange(filtro.campo, 'fim', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </template>

          <template v-if="filtro.tipo === 'numberrange'">
            <v-col
              :key="`${filtro.campo}-minimo-obrigatorio`"
              cols="12"
              sm="6"
              md="4"
            >
              <span class="filter-label">{{ filtro.label }} - Minimo</span>
              <v-text-field
                :value="getRangeValue(filtro.campo, 'minimo')"
                label="Minimo"
                dense
                solo-inverted
                type="number"
                class="compact-field"
                :error-messages="getErrorMessages(filtro.campo, 'minimo')"
                @input="updateNumberRange(filtro.campo, 'minimo', $event)"
              ></v-text-field>
            </v-col>

            <v-col
              :key="`${filtro.campo}-maximo-obrigatorio`"
              cols="12"
              sm="6"
              md="4"
            >
              <span class="filter-label">{{ filtro.label }} - Maximo</span>
              <v-text-field
                :value="getRangeValue(filtro.campo, 'maximo')"
                label="Maximo"
                dense
                solo-inverted
                type="number"
                class="compact-field"
                :error-messages="getErrorMessages(filtro.campo, 'maximo')"
                @input="updateNumberRange(filtro.campo, 'maximo', $event)"
              ></v-text-field>
            </v-col>
          </template>

          <v-col
            v-if="filtro.tipo === 'date'"
            :key="`${filtro.campo}-date-obrigatorio`"
            cols="12"
            sm="6"
            md="4"
          >
            <span class="filter-label">{{ filtro.label }}</span>
            <v-menu
              v-model="menusDatas[`${filtro.campo}-unica`]"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(valoresFiltros[filtro.campo])"
                  :label="filtro.label"
                  dense
                  solo-inverted
                  readonly
                  class="compact-field"
                  :error-messages="getErrorMessages(filtro.campo)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                :value="valoresFiltros[filtro.campo]"
                @input="updateSingleDate(filtro.campo, $event)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </template>

        <v-col cols="12" class="py-0"></v-col>

        <template v-for="filtro in filtrosOpcionaisAdicionados">
          <template v-if="filtro.tipo === 'multiselect'">
            <v-col :key="`${filtro.campo}-opcional`" cols="12" sm="11" md="11">
              <span class="filter-label">{{ filtro.label }}</span>
              <v-select
                v-model="valoresFiltros[filtro.campo]"
                :items="filtro.opcoes"
                :label="filtro.label"
                multiple
                dense
                solo-inverted
                class="compact-field"
              >
                <template v-slot:selection="{ item, index }">
                  <span
                    v-if="
                      shouldShowSelection(index, valoresFiltros[filtro.campo])
                    "
                  >
                    {{ item }}
                    <span
                      v-if="
                        shouldShowSelectionComma(
                          index,
                          valoresFiltros[filtro.campo],
                        )
                      "
                    >
                      ,
                    </span>
                  </span>
                  <span v-else-if="index === 2"> ... </span>
                </template>
              </v-select>
            </v-col>

            <v-col
              :key="`${filtro.campo}-btn`"
              cols="12"
              sm="1"
              md="1"
              align-self="center"
            >
              <v-btn
                @click="removerFiltroOpcional(filtro.campo)"
                color="#FF5733"
                small
                fab
                outlined
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </template>

          <template v-if="filtro.tipo === 'daterange'">
            <v-col
              :key="`${filtro.campo}-inicio-opcional`"
              cols="12"
              sm="5"
              md="5"
            >
              <span class="filter-label">{{ filtro.label }} - Inicial</span>
              <v-menu
                v-model="menusDatas[`${filtro.campo}-inicio`]"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(getRangeValue(filtro.campo, 'inicio'))"
                    label="Data Inicial"
                    dense
                    solo-inverted
                    readonly
                    class="compact-field"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  :value="getRangeValue(filtro.campo, 'inicio')"
                  @input="updateDateRange(filtro.campo, 'inicio', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col
              :key="`${filtro.campo}-fim-opcional`"
              cols="12"
              sm="6"
              md="6"
            >
              <span class="filter-label">{{ filtro.label }} - Final</span>
              <v-menu
                v-model="menusDatas[`${filtro.campo}-fim`]"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(getRangeValue(filtro.campo, 'fim'))"
                    label="Data Final"
                    dense
                    solo-inverted
                    readonly
                    class="compact-field"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  :value="getRangeValue(filtro.campo, 'fim')"
                  @input="updateDateRange(filtro.campo, 'fim', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col
              :key="`${filtro.campo}-btn`"
              cols="12"
              sm="1"
              md="1"
              align-self="center"
            >
              <v-btn
                @click="removerFiltroOpcional(filtro.campo)"
                color="#FF5733"
                small
                fab
                outlined
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </template>

          <template v-if="filtro.tipo === 'numberrange'">
            <v-col
              :key="`${filtro.campo}-minimo-opcional`"
              cols="12"
              sm="5"
              md="5"
            >
              <span class="filter-label">{{ filtro.label }} - Minimo</span>
              <v-text-field
                :value="getRangeValue(filtro.campo, 'minimo')"
                label="Minimo"
                dense
                solo-inverted
                type="number"
                class="compact-field"
                @input="updateNumberRange(filtro.campo, 'minimo', $event)"
              ></v-text-field>
            </v-col>

            <v-col
              :key="`${filtro.campo}-maximo-opcional`"
              cols="12"
              sm="6"
              md="6"
            >
              <span class="filter-label">{{ filtro.label }} - Maximo</span>
              <v-text-field
                :value="getRangeValue(filtro.campo, 'maximo')"
                label="Maximo"
                dense
                solo-inverted
                type="number"
                class="compact-field"
                @input="updateNumberRange(filtro.campo, 'maximo', $event)"
              ></v-text-field>
            </v-col>

            <v-col
              :key="`${filtro.campo}-btn`"
              cols="12"
              sm="1"
              md="1"
              align-self="center"
            >
              <v-btn
                @click="removerFiltroOpcional(filtro.campo)"
                color="#FF5733"
                small
                fab
                outlined
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </template>

          <template v-if="filtro.tipo === 'date'">
            <v-col
              :key="`${filtro.campo}-date-opcional`"
              cols="12"
              sm="11"
              md="11"
            >
              <span class="filter-label">{{ filtro.label }}</span>
              <v-menu
                v-model="menusDatas[`${filtro.campo}-unica`]"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(valoresFiltros[filtro.campo])"
                    :label="filtro.label"
                    dense
                    solo-inverted
                    readonly
                    class="compact-field"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  :value="valoresFiltros[filtro.campo]"
                  @input="updateSingleDate(filtro.campo, $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col
              :key="`${filtro.campo}-btn`"
              cols="12"
              sm="1"
              md="1"
              align-self="center"
            >
              <v-btn
                @click="removerFiltroOpcional(filtro.campo)"
                color="#FF5733"
                small
                fab
                outlined
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </template>
        </template>

        <v-col v-if="filtrosOpcionaisDisponiveis.length" cols="12" class="pb-0">
          <v-divider></v-divider>
        </v-col>

        <v-col v-if="filtrosOpcionaisDisponiveis.length" cols="12" class="pb-0">
          <span class="filter-label">Filtros opcionais</span>
        </v-col>
        <v-col
          v-if="!filtrosOpcionaisAdicionados.length"
          cols="12"
          class="py-0"
        >
          <span class="caption text--secondary">
            Adicione somente os filtros opcionais que fizerem sentido para a
            consulta.
          </span>
        </v-col>

        <v-col
          v-if="filtrosOpcionaisDisponiveis.length"
          cols="12"
          sm="8"
          md="4"
        >
          <v-select
            v-model="filtroOpcionalSelecionado"
            :items="filtrosOpcionaisDisponiveis"
            item-text="label"
            item-value="campo"
            label="Selecionar filtro opcional"
            dense
            solo-inverted
            class="compact-field"
            :disabled="!filtrosOpcionaisDisponiveis.length"
          ></v-select>
        </v-col>

        <v-col
          v-if="filtrosOpcionaisDisponiveis.length"
          cols="12"
          sm="4"
          md="2"
          class="d-flex align-center"
        >
          <v-btn
            @click="adicionarFiltroOpcional"
            color="#4682B4"
            small
            :disabled="!filtroOpcionalSelecionado"
          >
            Adicionar Filtro
            <v-icon style="margin-left: 8px">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions class="justify-end my-4">
        <v-btn
          @click="alternarVisibilidade"
          color="#4682B4"
          small
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
          <v-icon style="margin-left: 8px" dark>
            {{ mostrarFiltro ? "mdi-eye-off" : "mdi-eye" }}
          </v-icon>
        </v-btn>

        <v-btn
          v-if="mostrarFiltro"
          @click="limparFiltro"
          color="#4682B4"
          small
          outlined
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          Limpar
        </v-btn>

        <v-btn
          v-if="mostrarFiltro"
          @click="consultar"
          color="#4682B4"
          small
          :loading="loading"
          style="font-size: 14px !important; font-weight: bold"
        >
          Consultar
          <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
const EMPRESAS = [
  "A FLOR DO CAFÉ",
  "CEMITERIO PREVIDA",
  "CEMITERIO PREVIDA SÃO MIGUEL",
  "MEMORIAL PARQUE MACEIÓ",
  "PARQUE DAS FLORES",
  "PARQUE DO AGRESTE",
  "PREVIDA",
];

const TIPOS_CONTRATO = ["PLANOS", "CEMITERIOS"];

const PRODUTOS_POR_TIPO = {
  PLANOS: [
    "COMPLETO",
    "FAMILIA",
    "INTEGRAL",
    "P23",
    "TOTAL",
    "PF - AMPARO",
    "PROTEÇÃO",
    "PV - AMIGO",
    "PV - BRONZE",
    "PV - CREMAÇÃO COM CERIMÔNIA",
    "PV - DIAMANTE",
    "PV - EMPRESARIAL",
    "PV - EMPRESARIAL - EMPRESA",
    "PV - ESPECIAL",
    "PV - ESMERALDA",
    "PV - ESSENCIAL",
    "PV - IDEAL",
    "PV - MAIOR",
    "PV - MAIS",
    "PV - MASTER GOLD",
    "PV - MELHOR",
    "PV - PLANO PJ",
    "PV - PLUS",
    "PV - POLICIA MILITAR",
    "PV - PRATA",
    "PV - PREVIDA",
    "PV - PREVIPARQ DO AGRESTE",
    "PV - RUBI",
    "PV - SÃO MATHEUS",
  ],
  CEMITERIOS: [
    "CONCESSÃO DE COLUMBÁRIO",
    "CONCESSÃO DE JAZIGOS",
    "CONCESSÃO DE OSSÁRIO",
    "VENDA DE COLUMBÁRIO",
    "VENDA DE JAZIGOS - IMEDIATO",
    "VENDA DE JAZIGOS - PREVENTIVO",
    "VENDA DE JAZIGOS - TRANSITÓRIO",
  ],
};

const FILTER_DEFINITIONS = [
  {
    campo: "empresa",
    label: "Empresa",
    tipo: "multiselect",
    obrigatorio: true,
    opcoes: EMPRESAS,
  },
  {
    campo: "tiposContrato",
    label: "Tipo de Contrato",
    tipo: "multiselect",
    obrigatorio: true,
    opcoes: TIPOS_CONTRATO,
  },
  {
    campo: "statusContrato",
    label: "Status do Contrato",
    tipo: "multiselect",
    obrigatorio: true,
    opcoes: ["ATIVO", "CANCELADO"],
  },
  {
    campo: "dataContrato",
    label: "Data do Contrato",
    tipo: "daterange",
    obrigatorio: true,
  },
  {
    campo: "dataCancelamento",
    label: "Data de Cancelamento",
    tipo: "daterange",
    obrigatorio: false,
  },
  {
    campo: "idadeTitular",
    label: "Idade do Titular",
    tipo: "numberrange",
    obrigatorio: false,
  },
  {
    campo: "ticketMedio",
    label: "Ticket Medio",
    tipo: "numberrange",
    obrigatorio: false,
  },
  {
    campo: "inadimplencia",
    label: "Inadimplencia",
    tipo: "numberrange",
    obrigatorio: false,
  },
  {
    campo: "produtos",
    label: "Produto",
    tipo: "multiselect",
    obrigatorio: false,
    opcoes: [],
    dinamico: true,
  },
  {
    campo: "quantidadeFalecidos",
    label: "Quantidade de Falecidos",
    tipo: "numberrange",
    obrigatorio: false,
  },
  {
    campo: "ultimoFalecidoAte",
    label: "Ultimo Falecido Ate",
    tipo: "date",
    obrigatorio: false,
  },
];

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function getEmptyValueByType(tipo) {
  if (tipo === "multiselect") {
    return [];
  }

  if (tipo === "daterange") {
    return { inicio: null, fim: null };
  }

  if (tipo === "numberrange") {
    return { minimo: null, maximo: null };
  }

  return null;
}

function hasValue(tipo, valor) {
  if (tipo === "multiselect") {
    return Array.isArray(valor) && valor.length > 0;
  }

  if (tipo === "daterange") {
    return Boolean(valor && valor.inicio && valor.fim);
  }

  if (tipo === "numberrange") {
    if (!valor) {
      return false;
    }

    return (
      (valor.minimo !== null && valor.minimo !== "") ||
      (valor.maximo !== null && valor.maximo !== "")
    );
  }

  return valor !== null && valor !== "";
}

export default {
  name: "ConsultaDinamicaFiltros",

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mostrarFiltro: true,
      definicoesFiltros: clone(FILTER_DEFINITIONS),
      valoresFiltros: {},
      filtrosAdicionados: [],
      filtroOpcionalSelecionado: null,
      validationErrors: {},
      menusDatas: {},
      user: null,
    };
  },

  computed: {
    filtrosObrigatorios() {
      return this.definicoesFiltros
        .filter((filtro) => filtro.obrigatorio)
        .map((filtro) => {
          if (filtro.campo === "empresa") {
            return {
              ...filtro,
              opcoes: this.empresasFiltradas,
            };
          }
          return filtro;
        });
    },

    filtrosOpcionaisDisponiveis() {
      return this.definicoesFiltros
        .filter(
          (filtro) =>
            !filtro.obrigatorio &&
            !this.filtrosAdicionados.includes(filtro.campo),
        )
        .map((filtro) => {
          if (filtro.campo === "produtos") {
            return {
              ...filtro,
              opcoes: this.produtosFiltrados,
            };
          }
          return filtro;
        });
    },

    filtrosOpcionaisAdicionados() {
      return this.definicoesFiltros
        .filter((filtro) => this.filtrosAdicionados.includes(filtro.campo))
        .map((filtro) => {
          if (filtro.campo === "produtos") {
            return {
              ...filtro,
              opcoes: this.produtosFiltrados,
            };
          }
          return filtro;
        });
    },

    empresasFiltradas() {
      return EMPRESAS.filter((empresa) => this.hasPermission(empresa));
    },

    produtosFiltrados() {
      const tiposSelecionados = this.valoresFiltros.tiposContrato || [];

      if (!tiposSelecionados.length) {
        return [];
      }

      const produtosUnicos = new Set();
      tiposSelecionados.forEach((tipo) => {
        const produtos = PRODUTOS_POR_TIPO[tipo] || [];
        produtos.forEach((produto) => produtosUnicos.add(produto));
      });

      return Array.from(produtosUnicos).sort();
    },
  },

  created() {
    this.carregarUsuario();
    this.inicializarFiltros();
  },

  methods: {
    carregarUsuario() {
      const userJson = sessionStorage.getItem("user");
      if (userJson) {
        this.user = JSON.parse(userJson);
      }
    },

    hasPermission(empresa) {
      if (!this.user) return false;

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      }

      const requiredRoles = empresa
        .split(",")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => this.user.roles.includes(role));
    },

    inicializarFiltros() {
      this.valoresFiltros = this.createInitialFilterValues(
        this.definicoesFiltros,
      );
      this.inicializarMenus(this.definicoesFiltros);
      this.setDefaultValues();
    },

    setDefaultValues() {
      // Primeira empresa com permissão
      if (this.empresasFiltradas.length > 0) {
        this.$set(this.valoresFiltros, "empresa", [this.empresasFiltradas[0]]);
      }

      // Tipo: PLANOS
      this.$set(this.valoresFiltros, "tiposContrato", ["PLANOS"]);

      // Status: ATIVO
      this.$set(this.valoresFiltros, "statusContrato", ["ATIVO"]);

      // Data: mês passado (início e fim)
      const datasMesPassado = this.getLastMonthDates();
      this.$set(this.valoresFiltros, "dataContrato", {
        inicio: datasMesPassado.inicio,
        fim: datasMesPassado.fim,
      });
    },

    getLastMonthDates() {
      const hoje = new Date();
      const primeiroDiaMesPassado = new Date(
        hoje.getFullYear(),
        hoje.getMonth() - 1,
        1,
      );
      const ultimoDiaMesPassado = new Date(
        hoje.getFullYear(),
        hoje.getMonth(),
        0,
      );

      return {
        inicio: this.formatDateISO(primeiroDiaMesPassado),
        fim: this.formatDateISO(ultimoDiaMesPassado),
      };
    },

    formatDateISO(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    inicializarMenus(definicoes) {
      definicoes.forEach((filtro) => {
        if (filtro.tipo === "daterange") {
          this.$set(this.menusDatas, `${filtro.campo}-inicio`, false);
          this.$set(this.menusDatas, `${filtro.campo}-fim`, false);
        }

        if (filtro.tipo === "date") {
          this.$set(this.menusDatas, `${filtro.campo}-unica`, false);
        }
      });
    },

    createInitialFilterValues(definicoes) {
      return definicoes.reduce((acc, filtro) => {
        acc[filtro.campo] = getEmptyValueByType(filtro.tipo);
        return acc;
      }, {});
    },

    validateRequiredFilters() {
      const errors = {};

      this.definicoesFiltros
        .filter((filtro) => filtro.obrigatorio)
        .forEach((filtro) => {
          const valor = this.valoresFiltros[filtro.campo];

          if (filtro.tipo === "multiselect" && !hasValue(filtro.tipo, valor)) {
            errors[filtro.campo] = { geral: "Selecione pelo menos uma opcao." };
          }

          if (filtro.tipo === "daterange") {
            const inicio = valor && valor.inicio;
            const fim = valor && valor.fim;

            if (!inicio) {
              errors[filtro.campo] = {
                ...(errors[filtro.campo] || {}),
                inicio: "Informe a data inicial.",
              };
            }

            if (!fim) {
              errors[filtro.campo] = {
                ...(errors[filtro.campo] || {}),
                fim: "Informe a data final.",
              };
            }
          }
        });

      return {
        isValid: Object.keys(errors).length === 0,
        errors,
      };
    },

    buildPayload() {
      const filtros = this.definicoesFiltros
        .filter(
          (filtro) =>
            filtro.obrigatorio ||
            this.filtrosAdicionados.includes(filtro.campo),
        )
        .reduce((acc, filtro) => {
          const valor = this.valoresFiltros[filtro.campo];

          if (hasValue(filtro.tipo, valor)) {
            acc[filtro.campo] = clone(valor);
          }

          return acc;
        }, {});

      return { filtros };
    },

    buildAppliedFilters(payload) {
      return Object.keys(payload.filtros)
        .map((campo) => {
          const definicao = this.definicoesFiltros.find(
            (filtro) => filtro.campo === campo,
          );
          const valor = payload.filtros[campo];

          if (!definicao) {
            return null;
          }

          if (definicao.tipo === "multiselect") {
            return `${definicao.label}: ${valor.join(", ")}`;
          }

          if (definicao.tipo === "daterange") {
            return `${definicao.label}: ${this.formatDate(
              valor.inicio,
            )} ate ${this.formatDate(valor.fim)}`;
          }

          if (definicao.tipo === "numberrange") {
            const minimo =
              valor.minimo !== null && valor.minimo !== "" ? valor.minimo : "-";
            const maximo =
              valor.maximo !== null && valor.maximo !== "" ? valor.maximo : "-";

            return `${definicao.label}: ${minimo} ate ${maximo}`;
          }

          if (definicao.tipo === "date") {
            return `${definicao.label}: ${this.formatDate(valor)}`;
          }

          return `${definicao.label}: ${valor}`;
        })
        .filter(Boolean);
    },

    shouldShowSelection(index, valores) {
      return Array.isArray(valores) && (valores.length <= 2 || index < 2);
    },

    shouldShowSelectionComma(index, valores) {
      return Array.isArray(valores) && index === 0 && valores.length >= 2;
    },

    getRangeValue(campo, chave) {
      const valor = this.valoresFiltros[campo];
      return valor && valor[chave] ? valor[chave] : null;
    },

    updateDateRange(campo, chave, valor) {
      const atual = { ...(this.valoresFiltros[campo] || {}) };
      atual[chave] = valor;
      this.$set(this.valoresFiltros, campo, atual);
      this.$set(this.menusDatas, `${campo}-${chave}`, false);
      this.clearFieldErrors(campo, chave);
    },

    updateNumberRange(campo, chave, valor) {
      const atual = { ...(this.valoresFiltros[campo] || {}) };
      atual[chave] = valor === "" ? null : Number(valor);
      this.$set(this.valoresFiltros, campo, atual);
      this.clearFieldErrors(campo, chave);
    },

    updateSingleDate(campo, valor) {
      this.$set(this.valoresFiltros, campo, valor);
      this.$set(this.menusDatas, `${campo}-unica`, false);
      this.clearFieldErrors(campo, "geral");
    },

    clearFieldErrors(campo, chave) {
      if (!this.validationErrors[campo]) {
        return;
      }

      const erros = { ...this.validationErrors[campo] };

      if (chave && erros[chave]) {
        delete erros[chave];
      }

      if (!chave && erros.geral) {
        delete erros.geral;
      }

      if (Object.keys(erros).length === 0) {
        this.$delete(this.validationErrors, campo);
        return;
      }

      this.$set(this.validationErrors, campo, erros);
    },

    getErrorMessages(campo, chave = "geral") {
      const erro = this.validationErrors[campo];

      if (!erro || !erro[chave]) {
        return [];
      }

      return [erro[chave]];
    },

    formatDate(data) {
      if (!data) {
        return "";
      }

      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    adicionarFiltroOpcional() {
      if (
        !this.filtroOpcionalSelecionado ||
        this.filtrosAdicionados.includes(this.filtroOpcionalSelecionado)
      ) {
        return;
      }

      this.filtrosAdicionados.push(this.filtroOpcionalSelecionado);
      this.filtroOpcionalSelecionado = null;
    },

    removerFiltroOpcional(campo) {
      this.filtrosAdicionados = this.filtrosAdicionados.filter(
        (filtro) => filtro !== campo,
      );

      const definicao = this.definicoesFiltros.find(
        (filtro) => filtro.campo === campo,
      );
      const valorInicial = this.createInitialFilterValues([definicao]);

      this.$set(this.valoresFiltros, campo, valorInicial[campo]);
      this.$delete(this.validationErrors, campo);
    },

    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },

    limparFiltro() {
      this.filtrosAdicionados = [];
      this.filtroOpcionalSelecionado = null;
      this.validationErrors = {};
      this.valoresFiltros = this.createInitialFilterValues(
        this.definicoesFiltros,
      );
    },

    consultar() {
      const validation = this.validateRequiredFilters();

      this.validationErrors = validation.errors;

      if (!validation.isValid) {
        this.$emit(
          "erro",
          "Preencha os filtros obrigatorios antes de consultar.",
        );
        return;
      }

      const payload = this.buildPayload();
      const appliedFilters = this.buildAppliedFilters(payload);

      this.$emit("consultar", {
        payload,
        appliedFilters,
      });
    },
  },
};
</script>

<style scoped>
.compact-field {
  font-size: 14px;
}

.custom-filter-background {
  padding-top: 12px;
}

.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}
</style>
